const GetLocalStorageUserId=()=>{
    const localdata = localStorage.getItem("sundorbonBookingUserDetails");
    const localStorageObj = JSON.parse(localdata);
    return localStorageObj?.Id.toString()
}

export default GetLocalStorageUserId